module.exports = __webpack_public_path__ + "static/media/ico-home.b9e48d59.svg";